module.exports = __webpack_public_path__ + "img/no-user-pic.cc415b5e.svg";